<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <form @submit.prevent="submit">
      <div class="modal-card">
        <header class="modal-card-head">
          <h1 class="is-title-header modal-card-title">
            {{ action }}
          </h1>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div class="column">
              <b-field label="Customer">
                <b-select
                  name="customer"
                  :disabled="!isAdd"
                  v-model="formData.customer"
                  expanded
                  placeholder="Please select"
                  required
                >
                  <option
                    v-for="(option, index) in customers"
                    :value="option.id"
                    :key="index"
                    selected
                  >
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>
              <b-field label="Country">
                <b-select
                  expanded
                  required
                  name="country"
                  v-model="formData.country"
                  v-on:input="filterScheme"
                  :disabled="!isAdd"
                  placeholder="Please select"
                >
                  <option
                    v-for="(option, index) in countries"
                    :value="option.id"
                    :key="index"
                  >
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>

              <b-field label="Scheme">
                <b-select
                  expanded
                  required
                  name="scheme"
                  v-model="formData.scheme"
                  v-on:input="filterStream"
                  :disabled="!isAdd"
                  placeholder="Please select"
                >
                  <option
                    v-for="(option, index) in schemes"
                    :value="option.id"
                    :key="index"
                  >
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>

              <b-field label="Stream">
                <b-select
                  expanded
                  required
                  name="stream"
                  v-model="formData.stream"
                  v-on:input="filterReportingTypes"
                  :disabled="!isAdd"
                  placeholder="Please select"
                >
                  <option
                    v-for="(option, index) in streams"
                    :value="option.id"
                    :key="index"
                  >
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>
              <b-field label="Reporting Category">
                <b-select
                  expanded
                  required
                  name="reporting_category"
                  v-model="formData.reporting_main_category"
                  v-on:input="filterReportingSubCategories"
                  :disabled="!isAdd"
                  placeholder="Please select"
                >
                  <option
                    v-for="(option, index) in reportingCategories"
                    :value="option.main_category"
                    :key="index"
                  >
                    {{ option.main_category }}
                  </option>
                </b-select>
              </b-field>
              <b-field
                label="Reporting Sub Category"
                v-if="reportingSubCategories"
              >
                <b-select
                  expanded
                  required
                  name="reporting_sub_category"
                  v-model="formData.reporting_sub_category"
                  v-on:input="checkReportingSubCategories"
                  :disabled="!isAdd"
                  placeholder="Please select"
                >
                  <option
                    v-for="(option, index) in reportingSubCategories"
                    :value="option.sub_category"
                    :key="index"
                  >
                    {{ option.sub_category }}
                  </option>
                </b-select>
              </b-field>
              <b-field label="Select a Field">
                <b-select
                  expanded
                  required
                  name="chosen_field"
                  v-on:input="checkChoosenField"
                  v-model="formData.chosen_field"
                  :disabled="!isAdd"
                  placeholder="Please select"
                >
                  <option value="fee_per_kg">Fee Per KG</option>
                  <option value="fee_per_unit">Fee Per Unit</option>
                </b-select>
              </b-field>
              <b-field
                label="Fee Per KG"
                v-if="formData.chosen_field == 'fee_per_kg'"
              >
                <b-input
                  :disabled="!isAdd"
                  required
                  v-model="formData.fee_per_kg"
                ></b-input>
              </b-field>
              <b-field
                label="Fee Per Unit"
                v-if="formData.chosen_field == 'fee_per_unit'"
              >
                <b-input
                  :disabled="!isAdd"
                  required
                  v-model="formData.fee_per_unit"
                ></b-input>
              </b-field>
              <b-field label="Valid From">
                <b-datepicker
                  name="valid_from"
                  :disabled="!isAdd"
                  v-model="formData.valid_from"
                  :date-formatter="dateFormatter"
                  icon="calendar-today"
                  trap-focus
                  editable
                  required
                >
                  <b-button
                    type="is-danger"
                    @click="formData.valid_from = null"
                  >
                    <b-icon icon="close"></b-icon>
                    <span>Clear</span>
                  </b-button>
                </b-datepicker>
              </b-field>
              <b-field label="Valid To">
                <b-datepicker
                  name="valid_to"
                  :disabled="!isAdd"
                  v-model="formData.valid_to"
                  :date-formatter="dateFormatter"
                  icon="calendar-today"
                  trap-focus
                  editable
                  required
                >
                  <b-button type="is-danger" @click="formData.valid_to = null">
                    <b-icon icon="close"></b-icon>
                    <span>Clear</span>
                  </b-button>
                </b-datepicker>
              </b-field>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot" v-if="isAdd">
          <b-button slot="right" native-type="submit" type="is-primary">
            Save
          </b-button>
          <b-button slot="right" type="is-danger" @click="cancel">
            Cancel
          </b-button>
        </footer>
        <footer class="modal-card-foot" v-if="!isAdd">
          <b-button
            v-if="disable && this.action !== 'View'"
            slot="right"
            type="is-danger"
            @click="remove"
          >
            Delete
          </b-button>
        </footer>
      </div>
    </form>
  </b-modal>
</template>

<script>
import CustomerSpecificPricesService from "@/services/CustomerSpecificPricesService";
import CustomerProfileDataService from "../../services/CustomerProfileDataService";
import SchemeDataService from "../../services/SchemeDataService";
export default {
  name: "CustomerSpecificFeesAddView",
  props: {
    action: {
      type: String,
      default: "Inserts"
    },
    isAdd: {
      type: Boolean,
      default: true
    },
    isEdit: {
      type: Boolean,
      default: true
    },
    isActive: {
      type: Boolean,
      default: false
    },
    editObjectName: {
      type: Object,
      default: () => {
        return {
          customer: "",
          country: "",
          scheme: "",
          stream: "",
          reporting_main_category: null,
          reporting_category_id: null,
          reporting_sub_categories: null,
          fee_per_kg: null,
          fee_per_unit: null,
          valid_from: null,
          valid_to: null
        };
      }
    },
    customerId: {
      type: Number,
      default: -1
    },
    country: {
      type: Array,
      default: null
    },
    scheme: {
      type: Array,
      default: null
    },
    container: {
      type: Array,
      default: null
    },
    isDelete: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      isModalActive: false,
      customers: [],
      reportingCategories: [],
      reportingSubCategories: [],
      customerSpecificPricesService: new CustomerSpecificPricesService(),
      customerDataService: new CustomerProfileDataService(),
      schemeDataService: new SchemeDataService(),
      countries: [],
      streams: [],
      schemes: [],
      formData: {}
    };
  },
  mounted() {
    this.fetchCustomerList();
  },
  computed: {
    disable() {
      if (this.action == "Edit") {
        return false;
      } else if (this.action == "View") {
        return true;
      } else if (this.action == "Delete") {
        return true;
      }
      return false;
    }
  },
  methods: {
    checkChoosenField() {
      this.formData.fee_per_kg = null;
      this.formData.fee_per_unit = null;
    },
    filterEditSchemeStream() {
      if (this.formData.country) {
        this.schemeDataService.getByCountry(this.formData.country).subscribe(
          response => {
            this.schemes = response;
            this.schemeDataService.get(this.formData.scheme).subscribe(
              response => {
                this.streams = response["container"];
              },
              e => {
                console.log(e);
              }
            );
          },
          e => {
            console.log(e);
          }
        );
      }
    },
    filterScheme(countryId) {
      this.schemeDataService.getByCountry(countryId).subscribe(
        response => {
          this.schemes = response;
          this.streams = [];
          this.reportingCategories = [];
          this.reportingSubCategories = [];
        },
        e => {
          console.log(e);
        }
      );
    },
    filterStream(schemeId) {
      if (schemeId) {
        this.schemeDataService.get(schemeId).subscribe(
          response => {
            this.streams = response["container"];
            this.reportingCategories = [];
            this.reportingSubCategories = [];
          },
          e => {
            console.log(e);
          }
        );
      }
    },
    filterEditReportingSubCategories(reportingCategory) {
      if (reportingCategory) {
        this.customerSpecificPricesService
          .getReportingTypes(this.formData)
          .subscribe(
            response => {
              this.reportingCategories = response;
              const data = this.reportingCategories.filter(
                i => reportingCategory == i.main_category
              );
              if (data.length > 0) {
                this.reportingSubCategories = data[0].sub_category;
              }
            },
            e => {
              console.log(e);
            }
          );
      }
    },
    checkReportingSubCategories(value) {
      if (value) {
        const data = this.reportingSubCategories.filter(
          i => value == i.sub_category
        );
        this.formData.reporting_category_id = data[0].id;
      }
    },
    filterReportingSubCategories(reportingCategory) {
      const data = this.reportingCategories.filter(
        i => reportingCategory == i.main_category
      );
      if (data.length > 0) {
        this.reportingSubCategories = data[0].sub_category;
      }
    },
    filterReportingTypes() {
      if (
        this.formData.country &&
        this.formData.scheme &&
        this.formData.stream
      ) {
        this.customerSpecificPricesService
          .getReportingTypes(this.formData)
          .subscribe(
            response => {
              this.reportingCategories = response;
              this.reportingSubCategories = [];
            },
            e => {
              console.log(e);
            }
          );
      }
    },
    dateFormatter(dt) {
      if (dt != null) {
        return dt.toLocaleDateString("fr-CA");
      }
      return dt;
    },
    dateParser(dt) {
      return new Date(Date.parse(dt));
    },
    fetchCustomerList() {
      this.customerDataService.getCustomerList(this.customerId, true).subscribe(
        customerProfiles => {
          this.customers = customerProfiles;
        },
        e => {
          console.log(e);
        }
      );
    },
    cancel() {
      this.$emit("cancel");
    },
    confirm() {
      this.$emit("confirm");
    },

    handleApiError(reason) {
      let errorMessage = "";
      for (const v in reason.response.data) {
        errorMessage += v + ": " + reason.response.data[v] + "<br>";
      }

      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
    },
    prepareMasterData(data) {
      const resultDict = {};
      for (const idx in data) {
        const dataDict = data[idx];
        resultDict[dataDict["id"]] = dataDict["name"];
      }
      return resultDict;
    },
    submit() {
      //if (this.formData.reporting_category_id) {
      if (this.action == "Add") {
        this.customerSpecificPricesService
          .create(this.formData)
          .subscribe(response => {
            this.$buefy.dialog.alert({
              title: "Success",
              message: "Customer Specific Fee Created!"
            });
            this.$emit("confirm", response);
          }, this.handleApiError);
      } else if (this.action == "Update") {
        this.customerSpecificPricesService
          .update(this.formData)
          .subscribe(response => {
            this.$buefy.dialog.alert({
              title: "Success",
              message: "Customer Specific Fee Updated!"
            });
            this.$emit("confirm", response);
          }, this.handleApiError);
      }
      // } else {
      //   this.$buefy.dialog.alert({
      //     title: "Error",
      //     message: "Please Select Reporting Sub Category ",
      //     type: "is-danger",
      //     ariaRole: "alertdialog",
      //     ariaModal: true
      //   });
      // }
    },
    remove() {
      this.customerSpecificPricesService
        .delete(this.formData.id)
        .subscribe(response => {
          this.$emit("confirm", response);
          this.$buefy.dialog.alert({
            title: "Success",
            message: "Customer Specific Fee Removed!"
          });
        }, this.handleApiError);
    },
    convertToDate(dt) {
      let newDate = null;
      if (dt == " - ") {
        return newDate;
      }
      if (dt != null) {
        newDate = new Date(dt);
      }
      return newDate;
    }
  },
  watch: {
    editObjectName(newValue) {
      this.formData = newValue;
      this.formData.valid_from = this.convertToDate(newValue.valid_from);
      this.formData.valid_to = this.convertToDate(newValue.valid_to);
      this.filterEditReportingSubCategories(newValue.reporting_main_category);
      this.filterEditSchemeStream(this.formData);
      if (newValue.fee_per_kg > 0) {
        this.formData.chosen_field = "fee_per_kg";
      }
      if (newValue.fee_per_unit > 0) {
        this.formData.chosen_field = "fee_per_unit";
      }
    },
    country(newValue) {
      this.countries = newValue;
    },
    container(newValue) {
      this.streams = newValue;
    },
    scheme(newValue) {
      this.schemes = newValue;
    },
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>
